import { IsNotEmpty, IsString } from 'class-validator';

export class NodeToSignDto {
  @IsNotEmpty()
  @IsString()
  signature: string;

  @IsNotEmpty()
  @IsString()
  document_hash: string;
}
